import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { authAPIUrls } from '../data';

export const logout = withLogger(async (): Promise<boolean> => {
  await authServiceAxiosClient.post(authAPIUrls.logout);
  return true;
});
